import {
  FETCH_CLAIM_LETTERS_ERROR,
  FETCH_CLAIM_LETTERS_PENDING,
  FETCH_CLAIM_LETTERS_SUCCESS,
} from '../actions/types';

const initialState = {
  data: [],
  loading: true,
  error: false,
};

export default function claimLettersReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CLAIM_LETTERS_PENDING:
      return { ...state, loading: true, data: [], error: false };
    case FETCH_CLAIM_LETTERS_SUCCESS:
      return { ...state, loading: false, data: action.data, error: false };
    case FETCH_CLAIM_LETTERS_ERROR:
      return { ...state, loading: false, data: [], error: true };
    default:
      return state;
  }
}
